(function ($, Drupal, drupalSettings) {
  "use strict";

  // Default behavior.
  /**
   * Adds a close button to the message.
   *
   * @param {object} message
   *   The message object.
   */
  const closeMessage = (message) => {
    const messageContainer = message.querySelector(".messages");
    const theKid = document.createElement("a");
    theKid.setAttribute("href", "#");
    theKid.classList.add("messageclose");
    theKid.setAttribute("title", "Close");
    theKid.innerHTML = "&times;";
    message.insertBefore(theKid, message.firstChild);

    theKid.addEventListener("click", (e) => {
      e.preventDefault();
      fadeOutEffect(message);
    });
  };

  /**
   * Fade-out effect to element.
   *
   * @param {object} fadeTarget
   *   The fade target.
   */
  const fadeOutEffect = (fadeTarget) => {
    var fadeEffect = setInterval(function () {
      if (!fadeTarget.style.opacity) {
        fadeTarget.style.opacity = 1;
      }
      if (fadeTarget.style.opacity > 0) {
        fadeTarget.style.opacity -= 0.1;
      } else {
        clearInterval(fadeEffect);
        fadeTarget.classList.add("hidden");
      }
    }, 20);
  };

  /**
   * Get messages from context.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the messageclose button behavior for messages.
   */
  Drupal.behaviors.messageclose = {
    attach(context) {
      once("messageclose", ".messages", context).forEach(closeMessage);
    },
  };

  // Default behavior.
  Drupal.behaviors.rocket_path_theme = {
    attach: function (context, settings) {
      var $context = $(context);

      if ($(window).width() < 992) {
        // burger
        $(".burger-wrapper")
          .off()
          .on("click", function () {
            if ($("body").hasClass("mobile-menu-open")) {
              $("body").removeClass("mobile-menu-open");
              $(".navigation-region").removeClass("show");
            } else {
              $("body").addClass("mobile-menu-open");
              setTimeout(function () {
                $(".navigation-region").addClass("show");
              }, 400);
            }
          });

        // mobile menu
        $(".menu-item--expanded > span")
          .off()
          .on("click", function () {
            $(this).parent().toggleClass("show-links");
          });
      }

      $(".header-search-block form .form-actions .form-submit")
        .off()
        .on("click", function (e) {
          if (
            $(
              ".header-right .header-search-block form .js-form-type-search input"
            ).val().length === 0
          ) {
            e.preventDefault();
            $("body").toggleClass("open-search");
          }
        });
        
        const windowWidth = $(window).width();

        // Helper function για να ελέγχουμε τον αριθμό των παιδιών πριν το slick
        const initSlickIfContent = (selector, minItems, slickOptions) => {
          const elements = once('slick-init', selector, context);
          $(elements).each(function () {
            // Μετράμε τα άμεσα παιδιά (slides)
            if ($(this).children().length >= minItems) {
              $(this).slick(slickOptions);
            }
          });
        };
  
        // 1. Hero Banner
        initSlickIfContent('.hero-banner .block-content > .field--field-elements', 2, {
          slidesToShow: 1,
          arrows: true,
          dots: true
        });

        initSlickIfContent('.hero-banner .block-content > .field--field-paragraphs', 2, {
          slidesToShow: 1,
          arrows: true,
          dots: true
        });
  
        // 2. Hero Paragraphs
        initSlickIfContent('.hero-paragraphs .field--field-paragraph', 2, {
          slidesToShow: 1,
          arrows: true,
          dots: true
        });
  
        // 3. Carousel Banners
        initSlickIfContent('.carousel-banners .block-content > div', 2, {
          slidesToShow: 1,
          arrows: false,
          dots: false,
          centerMode: true,
          focusOnSelect: true
        });
  
        // 4. Article Carousel
        initSlickIfContent('.paragraph--type--article-carousel > div', 2, {
          slidesToShow: 1,
          arrows: false,
          dots: false,
          centerMode: true,
          focusOnSelect: true,
          autoplay: true,
          autoplaySpeed: 2000
        });
  
        // 5. Quote Carousel (Διορθωμένη διπλή λογική)
        const quoteCarousel = once('slick-quote', '.quote-carousel .field--field-paragraph, .quote-carousel:not(.field--field-paragraph)', context);
        $(quoteCarousel).each(function () {
          if ($(this).children().length > 1) {
            $(this).slick({
              slidesToShow: 1,
              arrows: true,
              infinite: true,
              dots: false,
              autoplay: true,
              autoplaySpeed: 2000,
              responsive: [{ breakpoint: 601, settings: { arrows: false, dots: true } }]
            });
          }
        });
  
        // 6. Articles Carousel (Responsive)
        initSlickIfContent('.articles-carousel > div[class$="__content"]', 4, {
          slidesToShow: 3,
          arrows: true,
          infinite: true,
          dots: false,
          responsive: [
            { breakpoint: 768, settings: { slidesToShow: 2 } },
            { breakpoint: 601, settings: "unslick" }
          ]
        });
  
        // 7. Desktop Only Sliders (News, Insights, Related)
        if (windowWidth > 991) {
          // News & Publications
          initSlickIfContent('.view-news-publications.view-display-id-block_2 .view-content', 4, {
            slidesToShow: 3,
            arrows: true,
            infinite: true,
            dots: false
          });
  
          // Latest Insights
          initSlickIfContent('.view-latest-insights.view-display-id-block_2 .view-content', 4, {
            slidesToShow: 3,
            arrows: true,
            infinite: true,
            dots: false
          });
  
          // Insights Related Lawyers
          if (!$('body').hasClass('is-insight')) {
            initSlickIfContent('.field--field-related-lawyer .field--field-related-lawyer__content', 4, {
              slidesToShow: 3,
              arrows: true,
              infinite: true,
              dots: false
            });
          }
  
          // News Field
          initSlickIfContent('.field--field-news__content', 4, {
            slidesToShow: 3,
            arrows: true,
            dots: false
          });
        }
  
        // 8. Multi Media
        initSlickIfContent('.paragraph--type--multi-media .field--field-media', 2, {
          slidesToShow: 1,
          arrows: true,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000
        });
  
        // 9. Featured Articles
        initSlickIfContent('.featured-articles .view-content', 2, {
          slidesToShow: 1,
          arrows: true,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000
        });

      if ($(".field--field-practice-accordion__content__item").length) {
        $(
          ".field--field-practice-accordion__content__item > .paragraph--type--recent-experience"
        )
          .off()
          .on("click", function () {
            $(this).children().toggleClass("active");
            $(this).children(".field--field-content").slideToggle();
          });
      }

      if ($(".form-item-sort-by").length) {
        if ($(window).width() < 992) {
          $(".form-item-sort-by label")
            .off()
            .on("click", function () {
              $(this).parent().toggleClass("show");
            });
        }
      }

      var delay = 200,
        setTimeoutConst;
      $(".main-menu > ul.menu > .menu-item--expanded").hover(
        function (event) {
          setTimeoutConst = setTimeout(
            function (element) {
              element.addClass("open-submenu");
            },
            delay,
            $(this)
          );
        },
        function (event) {
          clearTimeout(setTimeoutConst);
          $(this).removeClass("open-submenu");
        }
      );

      // Lawyers filtering: Hide unpublished entities
      if ($("#edit-related-practices").length) {
        $("#edit-related-practices")
          .find("option")
          .each(function (option) {
            if ($(this).text() === "- Restricted access -") {
              $(this).hide();
            }
          });
      }
    },
  };

  $(document).ready(function () {
    $(".page-node-type-article .article__content video").prop("controls", true);
  });
})(jQuery, Drupal, drupalSettings);
